import { Text, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { dateFormat, dateTimeFormat } from "../../../utils/date";
import classes from "../list.module.css";

type Props = {
  value?: string | Date | null;
};

export function DateCell({ value }: Props) {
  const { t } = useTranslation("common");
  const dash = t("list.dash");

  if (!value) {
    return (
      <Text size="sm" c="dimmed" className={classes.dateCell}>
        {dash}
      </Text>
    );
  }

  const display = dateFormat(typeof value === "string" ? value : value.toISOString());
  const full = dateTimeFormat(value);

  if (display === "-" || !full || full === "-") {
    return (
      <Text size="sm" c="dimmed" className={classes.dateCell}>
        {dash}
      </Text>
    );
  }

  return (
    <Tooltip label={full} withArrow>
      <Text size="sm" className={classes.dateCell} component="span">
        {display}
      </Text>
    </Tooltip>
  );
}
